module.exports = __webpack_public_path__ + "static/media/weather.dc19b60d.svg";